<app-navbar></app-navbar>
<div class="container-wrapper">
  <div class="container">
    <h1 class="text-gray-700 mb-8">About Moving Picture Club .</h1>
    <p class="text-gray-600">
      Moving Picture Club is a one-stop collection of movies and TV shows. Our
      goal is to keep our visitors up to date on trending titles in the moving
      picture world. We bring you the most popular movies and TV shows along
      with details and video trailers. Disclaimer: The titles listed in the
      Moving Picture Club (and metadata including pictures and videos) are not
      properties of Moving Picture Club. They are collected from free and open
      data sources.
    </p>
    <div style="margin-top:40px;text-align: center;font-weight: 600;">
      <p class="text-gray-700">
        If you have any questions, comments, and/or suggestions, please feel
        free to contact us at
        <a style="color:blue" href="mailto:mopic.club@gmail.com" target="_blank"
        >mopic.club@gmail.com</a
      >
      </p>
     
    </div>
  </div>
</div>
<app-footer></app-footer>
